<script setup>
import ResponsiveView from "@/components/helper/ResponsiveView.vue";
import SubscribeMobile from "@/components/subscribe/SubscribeMobile.vue";
import SubscribeDesktop from "@/components/subscribe/SubscribeDesktop.vue";
import { useRouter } from "vue-router";

const router = useRouter();

function goBack() {
  router.back();
}
</script>

<template>
  <ResponsiveView mobile-only>
    <SubscribeMobile @go-back="goBack" />
  </ResponsiveView>
  <ResponsiveView desktop-only>
    <SubscribeDesktop />
  </ResponsiveView>
</template>
